import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';

/**
 * Generated class for the OffersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-offers',
  templateUrl: 'offers.html',
})
export class OffersPage {
  offersContent: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private cp:CommonProvider,private loadingCtrl:LoadingController) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad LoginPage');
	this.getAboutUsContent()
  }
  getAboutUsContent(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
  
  let data = this.cp.getOffersPage(loading) ;
	data.then((res:any)=>{
    loading.dismiss()
    var res=JSON.parse(res)
		 this.offersContent = res.Payload.knowledgearticles[0].content;
     //console.log(this.offersContent);
     
	}).catch(e=>loading.dismiss())
}

}



// WEBPACK FOOTER //
// ./src/pages/offers/offers.ts